import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import GlobalStyle from './styles/global';

import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useTheme } from './context/ThemeContext';
import { darkTheme, lightTheme } from './themes';
import AppProvider from './context';

import Routes from './routes';

const App: React.FC = () => {
  const { theme } = useTheme();

  return (
    <>
      <Router>
        <StyledThemeProvider theme={theme === 'dark' ? darkTheme : lightTheme}>
          <AppProvider>
            <Routes />
          </AppProvider>
        </StyledThemeProvider>

        <GlobalStyle />
      </Router>
    </>
  );
};

export default App;
